export default {
  splitIntoChunks(array, chunkAmount) {
    let result = [];
    for (let i = chunkAmount; i > 0; i--) {
      result.push(array.splice(0, Math.ceil(array.length / i)));
    }
    return result;
  }
}